import * as React from "react";
import { forwardRef } from "react";
const SvgIcConfirmed32 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14.203 26L25.281 7.77927L22.7176 6.22076L12.7595 22.5996L7.0532 16.9649L4.94531 19.0996L11.9334 26H14.203Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcConfirmed32);
export { ForwardRef as ReactComponent };
